module.exports = __webpack_public_path__ + "img/volume_off.dc6fb4ef.svg";